module.exports = __webpack_public_path__ + "media/subway/F-81d56ff3.png";